import React from 'react';
import styled from 'styled-components';
import LogoIcon from './icons/logo_new.svg';
import LogoSmallIcon from './icons/logo_new_small.svg';
import UpworkIcon from './icons/upwork.svg';
import MailIcon from './icons/mail.svg';

const Contacts = () => {
  return (
    <StyledContacts>
      <a className="logo" href="https://mappitall.com/" target="_blank" rel="noreferrer">
        <img className="full" src={LogoIcon} alt="logo" />
        <img className="small" src={LogoSmallIcon} alt="logo" width="25" height="25" />
      </a>
      <div className="right">
				<div className="title">
					<div>Like the map?</div>&nbsp;
					<a href="https://mappitall.com/" target="_blank" rel="noreferrer">Get in touch</a>
				</div>
        <div className="icons">
          <a href="https://www.upwork.com/freelancers/~01322a1d5306e7003e" target="_blank" rel="noreferrer">
            <img src={UpworkIcon} alt="upwork-logo" width="25" height="25" />
          </a>
          <a href="mailto:contact@mappitall.com">
            <img src={MailIcon} alt="mail-logo" width="25" height="25" />
          </a>
        </div>
      </div>
    </StyledContacts>
  );
}

const StyledContacts = styled.div`
  font-family: 'Space Grotesk', sans-serif;
  position: absolute;
  left: 20px;
  top: 20px;  
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 0px 4px 20px rgba(114, 119, 143, 0.2);
  backdrop-filter: blur(7px);
  border-radius: 10px;
  padding: 12px;
  max-width: fit-content;
  max-height: fit-content;
  color: #081538;
  z-index: 1000;

  @media screen and (max-width: 720px) {
    left: auto;
    top: auto;
    right: 10px;
    bottom: 50px;
    padding: 5px;

    img {
      width: 15px;
      height: 15px;
    }
  }

  .logo {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    margin-bottom: 5px;

    .small {
      display: none;
    }

    @media screen and (max-width: 720px) {
      .full {
        display: none;
      }
      .small {
        display: block;
      }
    }

  }
  
  .title {
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 720px) {
      display: none;
    }

    &, a, a:active, a:visited {
      font-weight: 700;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0.01em;
      color: #101010;
      text-decoration: none;
    }

    a:hover {
      text-decoration: underline;
    }
  }

  .icons {
    margin-top: 5px;

    @media screen and (max-width: 720px) {
      flex-direction: column;
    }

    &, a {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    a:not(:last-child) {
      margin-right: 10px;

      @media screen and (max-width: 720px) {
        margin-right: 0;
        margin-bottom: 5px;
      }

    }
  }

`;

export default Contacts;
